import React, { useRef, useEffect } from 'react';
import s from './CoachMark.scss';

function CoachMark(props) {
  const ref = useRef(null);
  const { onClickOutside } = props;

  useEffect(
    () => {
      const handleClickOutside = event => {
        if (
          ref.current &&
          !ref.current.contains(event.target) &&
          onClickOutside
        ) {
          onClickOutside();
        }
      };
      document.addEventListener('click', handleClickOutside, true);
      return () => {
        document.removeEventListener('click', handleClickOutside, true);
      };
    },
    [onClickOutside],
  );
  return (
    <div className={`${s.tooltip}`} ref={ref}>
      <div className={`${s.tooltiptext}`}>
        Find more topics in your city
        <span>OK, GOT IT</span>
      </div>
    </div>
  );
}

export default CoachMark;
